import {
  NotificationsLocalCache,
  WSNotificationsResponse,
} from "src/Modules/Arbitrage/types";

export const notificationsInitialState: NotificationsLocalCache = new Map();

export const notificationsReducer = (
  state: NotificationsLocalCache,
  action: WSNotificationsResponse
): NotificationsLocalCache => {
  console.log("Arbitrage OrderBooks Action:", action);

  switch (action.action) {
    case "SNAPSHOT":
      return new Map(action.data.map((item) => [item.id, item]));
    case "UPDATE":
      if (state) {
        const updatedState = new Map(state);
        updatedState.set(action.id, action.data);
        return updatedState;
      }
      return state;
    case "DELETE":
      if (state) {
        const updatedState = new Map(state);
        updatedState.delete(action.id);
        return updatedState;
      }
      return state;
    default:
      return state;
  }
};
